export default {
  "base": "size-4 shrink-0 align-sub"
}